export const formTypes = {
  FLOW: 'FLOW',
  MESSAGING: 'MESSAGING',
};

export const FormSectionType = {
  DOCUMENT_UPLOAD: 'DOCUMENT_UPLOAD',
  CONFERENCE_BRIDGE: 'CONFERENCE_BRIDGE',
  CUSTOM_SECTION: 'CUSTOM_SECTION',
  DEVICE_FILTER: 'DEVICE_FILTER',
  HANDLING_OPTIONS: 'HANDLING_OPTIONS',
  INCIDENT: 'INCIDENT',
  RECIPIENTS: 'RECIPIENTS',
  RESPONSE_CHOICES: 'RESPONSE_CHOICES',
  SENDER_OVERRIDES: 'SENDER_OVERRIDES',
  SITE_RECIPIENTS: 'SITE_RECIPIENTS',
  INCIDENT_TYPE_PROPERTIES: 'INCIDENT_TYPE_PROPERTIES',
};

export const PaidOnlyFormSections = [
  FormSectionType.CONFERENCE_BRIDGE,
  FormSectionType.HANDLING_OPTIONS,
  FormSectionType.SENDER_OVERRIDES,
];
